import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import Scanner from '../../../../../components/Scanner/Scanner';
import { ProductListElement } from 'components/ProductListElement/product-list-element';
export const DeviceElement = ({ device, onReset, serialNumberInput, onScannerDetect, isFetching, handleChange, handleSubmit, status, }) => {
    const [showScanner, setShowScanner] = useState(false);
    const onDetected = useCallback((result) => {
        onScannerDetect(result);
        setShowScanner(false);
    }, [onScannerDetect]);
    return (_jsxs("div", { children: [_jsx(ProductListElement, { isFetching: isFetching, onScannerClick: () => setShowScanner(true), title: device.name, serialNumberInputs: [serialNumberInput], handleSubmit: handleSubmit, handleChange: handleChange, serialNumbers: [device.serialNumber], status: status, onReset: onReset, onDelete: () => { } }), showScanner && (_jsx(Scanner, { onHeaderClick: () => setShowScanner(false), onDetected: onDetected }))] }));
};
